import tableAppContents from './tableAppContents';

export default {
  title: 'Contents',
  attributeName: 'appCategory',
  getURL: 'appId/areaId/appContentPlay',
  createURL: '',
  updateURL: 'appId/areaId/appContentPlayMultiple',
  removeURL: 'appId/areaId/appContentPlay',
  sessionParams: ['appId', 'areaId'],
  removeNameField:'name',
  removeText:'You are about to remove the content with name ##name##.',
  tableConfig: tableAppContents,
  autoUpdate: true,
};
